// extracted by mini-css-extract-plugin
export default {"search":"Search_search__3uJ62","input":"Search_input__h9cbd","icon":"Search_icon__RaNfa","clear":"Search_clear__rhD5x"};